export interface Volume {
  code: string
  name: string
  count: string
  /** Spine color from the product mockup. */
  color: string
  intro: string
  highlights: string[]
  note?: string
  result: string
}

const SESSIONS_NOTE = 'Includes 12 complete 60-minute sessions.'

export const volumes: Volume[] = [
  {
    code: '1',
    name: 'Foundations & Ready-to-Run Sessions',
    count: '12 sessions',
    color: '#3b82f6',
    intro: 'Build the essential actions every developing futsal player needs.',
    highlights: [
      'Ready position',
      'Sole control',
      'First touch',
      'Passing basics',
      'Pass + move',
      'Support angles',
      'Width & depth',
      '1v1 foundations',
      'Defensive body shape',
      'Pressing',
      'Attacking transitions',
      'Defensive transitions',
    ],
    note: SESSIONS_NOTE,
    result:
      'A clear technical and tactical foundation that connects ball control, movement, spacing, defending, pressing and transitions.',
  },
  {
    code: '2',
    name: 'Passing, Receiving & Ball Mastery',
    count: '12 sessions',
    color: '#22c55e',
    intro: 'Develop cleaner control, sharper passing and faster decisions in tight spaces.',
    highlights: [
      'Sole receiving',
      'First-touch direction',
      'Receiving across the body',
      'Passing angles',
      'One-touch combinations',
      'Two-touch combinations',
      'Wall passes',
      'Ball protection',
      'Close control',
      'Playing under pressure',
      'Fast circulation',
      'Combination play',
    ],
    note: SESSIONS_NOTE,
    result:
      'Players receive with more purpose, move the ball faster and maintain control under pressure.',
  },
  {
    code: '3',
    name: '1v1, Movement & Creating Space',
    count: '12 sessions',
    color: '#f97316',
    intro: 'Help players recognize when to attack, support, rotate and move away from the ball.',
    highlights: [
      'Attacking 1v1',
      'Defending 1v1',
      'Change of speed',
      'Change of direction',
      'Creating passing lanes',
      'Diagonal support',
      'Third-player movement',
      'Rotations',
      'Creating width',
      'Creating depth',
      'Fixing defenders',
      'Exploiting free space',
    ],
    note: SESSIONS_NOTE,
    result:
      'More intelligent movement, clearer passing options and better decisions around the ball.',
  },
  {
    code: '4',
    name: 'Defending, Pressing & Transitions',
    count: '12 sessions',
    color: '#ef4444',
    intro: 'Build a team that reacts together when possession changes.',
    highlights: [
      'Defensive body shape',
      'First defender',
      'Second defender',
      'Cover',
      'Balance',
      'Central protection',
      'Pressing triggers',
      'Collective pressing',
      'Winning the ball back',
      'Recovery runs',
      'Attack-to-defense transition',
      'Defense-to-attack transition',
    ],
    note: SESSIONS_NOTE,
    result:
      'Players understand who presses, who covers, where to recover and how to react faster after turnovers.',
  },
  {
    code: '5',
    name: 'Attacking Systems, Set Plays & Game Situations',
    count: '12 sessions',
    color: '#a855f7',
    intro: 'Turn technical actions into organized attacking futsal.',
    highlights: [
      'Attacking shape',
      'Numerical advantages',
      '2v1 situations',
      '3v2 situations',
      'Combination attacks',
      'Playing between lines',
      'Finishing actions',
      'Kick-ins',
      'Corners',
      'Restarts',
      'Quick attacks',
      'Game situations',
    ],
    note: SESSIONS_NOTE,
    result:
      'More organized attacking play and clearer solutions in common futsal situations.',
  },
  {
    code: '6',
    name: 'Practice Planning & Team Organization',
    count: '12 sessions',
    color: '#a1a1aa',
    intro: 'Turn individual drills into a repeatable coaching system.',
    highlights: [
      'Building a 60-minute session',
      'Choosing the main objective',
      'Organizing progressions',
      'Managing player numbers',
      'Reducing waiting time',
      'Adapting exercises',
      'Mixed-level groups',
      'Planning training weeks',
      'Managing intensity',
      'Coaching interventions',
      'Session review',
      'Team organization',
    ],
    note: SESSIONS_NOTE,
    result:
      'A repeatable structure you can use throughout the season instead of rebuilding every session from zero.',
  },
]
